import axios from "axios"

export function getProductDetail (id) {
  return new Promise((resolve, reject) => {
    axios.get(`/distributor/admin/api/v1/inventory/product/${id}`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data))
  });
};